import { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import FormInPhieuDialog from './components/PrintDialog';
import { PrintButtonProps } from './types';

const PrintButton = <T extends object>({
	label = 'In phiếu',
	fetchExport,
	params,
	className,
	typeBtn,
	keyBtn,
	isOnlyText = false,
	signatureParams,
	component,
}: PrintButtonProps<T>) => {
	const [openPrintDialog, setOpenPrintDialog] = useState(false);

	const hasSignature = signatureParams && process.env.REACT_APP_SIGNATURE_ENABLE === 'true';

	useEffect(() => {
		if (!keyBtn) return;

		window.addEventListener('keydown', onKeyDown);
		return () => {
			window.removeEventListener('keydown', onKeyDown);
		};
	}, []);

	const onKeyDown = (e: KeyboardEvent) => {
		if(e.key === keyBtn) {
			e.preventDefault();
			setOpenPrintDialog(true);
		}
	}

	return (
		<>
			{!isOnlyText ? (
				<Button
					className={`${typeBtn ? typeBtn : 'btn-fill'} ${className}`}
					onClick={() => {
						setOpenPrintDialog(true);
					}}
				>
					{label}
				</Button>
			) : (
				<span className={className} onClick={() => setOpenPrintDialog(true)}>
					{label}
				</span>
			)}

			{openPrintDialog && (
				<FormInPhieuDialog<T>
					show={openPrintDialog}
					onHide={() => {
						setOpenPrintDialog(false);
					}}
					fetchExport={fetchExport}
					params={params}
					hasSignature={hasSignature}
					signatureParams={signatureParams}
					component={component}
				/>
			)}
		</>
	);
};

export default PrintButton;
